(() => {
  // Several sections include this file; only run it once.
  if (window.__pickles) return;
  window.__pickles = true;

  const formatMoney = (cents, format) => {
    const fmt = format || '${{amount}}';
    const withDelims = (n, decimals, thousands, decimal) => {
      const [whole, frac] = (n / 100).toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  };

  const initProduct = (root) => {
    const variants = JSON.parse(root.querySelector('[data-pk-variants]').textContent);
    const colorIndex = parseInt(root.dataset.colorIndex, 10);
    const moneyFormat = root.dataset.moneyFormat;
    const hideCents = 'hideCents' in root.dataset;
    const money = (c) => {
      const s = formatMoney(c, moneyFormat);
      return hideCents && c % 100 === 0 ? s.replace(/[.,]00(?=\D*$)/, '') : s;
    };
    const form = root.querySelector('[data-pk-form]');
    const idInput = root.querySelector('[data-pk-variant-id]');
    const qtyInput = root.querySelector('[data-pk-qty]');
    const atc = root.querySelector('[data-pk-atc]');
    const errorEl = root.querySelector('[data-pk-error]');
    const bundles = [...root.querySelectorAll('[data-pk-bundle]')];

    let current = variants.find((v) => String(v.id) === idInput.value) || variants[0];

    const variantForColor = (color) =>
      variants.find((v) => v.options[colorIndex] === color &&
        v.options.every((o, i) => i === colorIndex || o === current.options[i])) ||
      variants.find((v) => v.options[colorIndex] === color);

    // Gallery
    const slides = [...root.querySelectorAll('.pk-gallery__slide')];
    const thumbs = [...root.querySelectorAll('.pk-gallery__thumb')];
    const showSlide = (i) => {
      slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => showSlide(+t.dataset.index)));

    const activeBundle = () => bundles.find((b) => b.classList.contains('is-active'));

    const renderPrices = () => {
      root.querySelector('[data-pk-price]').textContent = money(current.price);
      const compare = root.querySelector('[data-pk-compare]');
      const badge = root.querySelector('[data-pk-badge]');
      const onSale = current.compare_at_price > current.price;
      compare.hidden = badge.hidden = !onSale;
      if (onSale) {
        compare.textContent = money(current.compare_at_price);
        badge.textContent = `SAVE ${Math.round((1 - current.price / current.compare_at_price) * 100)}%`;
      }
      bundles.forEach((b) => {
        const qty = +b.dataset.qty;
        const disc = +b.dataset.discount || 0;
        const off = +b.dataset.off || 0;
        const was = Math.max(current.compare_at_price || 0, current.price) * qty;
        // Shopify puts each colour on its own cart line and rounds each line's discount down,
        // so price the bundle the same way to match checkout to the cent.
        const lines = new Map();
        const units = [...b.querySelectorAll('[data-pk-unit]')];
        if (units.length) units.forEach((sel) => lines.set(sel.value, (lines.get(sel.value) || 0) + 1));
        else lines.set('', qty);
        let total = 0;
        lines.forEach((n) => {
          const line = current.price * n;
          total += off ? line - Math.min(off, current.price) * n : line - Math.floor((line * disc) / 100);
        });
        b.querySelector('[data-pk-bundle-price]').textContent = money(total);
        const s = b.querySelector('[data-pk-bundle-compare]');
        s.textContent = was > total ? money(was) : '';
      });
      const b = activeBundle();
      const sticky = root.querySelector('[data-pk-sticky-price]');
      if (sticky) sticky.textContent = b ? b.querySelector('[data-pk-bundle-price]').textContent : money(current.price);
      atc.disabled = !current.available;
      atc.textContent = current.available ? atc.dataset.label : 'Sold out';
    };
    atc.dataset.label = atc.textContent.trim();

    const setVariant = (v) => {
      if (!v) return;
      current = v;
      idInput.value = v.id;
      const label = root.querySelector('[data-pk-color-label]');
      if (label && colorIndex >= 0) label.textContent = v.options[colorIndex];
      root.querySelectorAll('[data-pk-swatch]').forEach((s) => {
        const on = s.dataset.pkSwatch === v.options[colorIndex];
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-checked', on);
      });
      // Default every bundle unit to the newly picked colour.
      root.querySelectorAll('[data-pk-unit]').forEach((sel) => { sel.value = v.options[colorIndex]; });
      if (v.featured_media) {
        const i = slides.findIndex((s) => s.dataset.mediaId === String(v.featured_media.id));
        if (i >= 0) showSlide(i);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
      renderPrices();
    };

    root.querySelectorAll('[data-pk-swatch]').forEach((s) =>
      s.addEventListener('click', () => setVariant(variantForColor(s.dataset.pkSwatch))));

    bundles.forEach((b) => b.addEventListener('click', (e) => {
      if (e.target.closest('select') || b.classList.contains('is-sold-out')) return;
      bundles.forEach((x) => {
        x.classList.toggle('is-active', x === b);
        x.querySelector('input[type=radio]').checked = x === b;
      });
      qtyInput.value = b.dataset.qty;
      renderPrices();
    }));
    root.querySelectorAll('[data-pk-unit]').forEach((sel) => sel.addEventListener('change', renderPrices));

    // Colour picker sections elsewhere on the page can set the colour here.
    document.addEventListener('pickles:color', (e) => {
      const v = variantForColor(e.detail);
      if (v) setVariant(v);
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorEl.hidden = true;
      const b = activeBundle();
      const counts = new Map();
      const units = b ? [...b.querySelectorAll('[data-pk-unit]')] : [];
      if (units.length) {
        units.forEach((sel) => {
          const v = variantForColor(sel.value) || current;
          counts.set(v.id, (counts.get(v.id) || 0) + 1);
        });
      } else {
        counts.set(current.id, b ? +b.dataset.qty : 1);
      }
      const items = [...counts].map(([id, quantity]) => ({ id, quantity }));
      // Free gift for this bundle; the Buy X get Y discount makes it $0 at checkout.
      const giftId = (b && b.dataset.giftId) || root.dataset.giftId;
      if (giftId) items.push({ id: +giftId, quantity: 1 });
      atc.disabled = true;
      try {
        const res = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
      } catch (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
        atc.disabled = !current.available;
      }
    });

    // Sticky bar: visible once the main button scrolls out of view.
    const sticky = root.querySelector('[data-pk-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', !show);
        sticky.querySelector('button').tabIndex = show ? 0 : -1;
      }).observe(atc);
      sticky.querySelector('[data-pk-sticky-btn]').addEventListener('click', () => {
        root.scrollIntoView({ behavior: 'smooth' });
      });
    }

    // Delivery timeline
    const eta = root.querySelector('[data-pk-eta]');
    if (eta) {
      const fmt = (d) => d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
      const plus = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
      const range = (a, b) => `${fmt(plus(+a))} - ${fmt(plus(+b))}`;
      eta.querySelector('[data-eta-ordered]').textContent = fmt(new Date());
      eta.querySelector('[data-eta-ships]').textContent = range(eta.dataset.shipMin, eta.dataset.shipMax);
      eta.querySelector('[data-eta-delivered]').textContent = range(eta.dataset.deliverMin, eta.dataset.deliverMax);
    }

    renderPrices();
  };

  const initPicker = (root) => {
    const orb = root.querySelector('[data-pk-orb]');
    const name = root.querySelector('[data-pk-picker-name]');
    const tagline = root.querySelector('[data-pk-picker-tagline]');
    const buttons = [...root.querySelectorAll('[data-pk-pick]')];
    let selected = buttons[0] && buttons[0].dataset.pkPick;
    buttons.forEach((btn) => btn.addEventListener('click', () => {
      buttons.forEach((b) => b.classList.toggle('is-active', b === btn));
      orb.style.setProperty('--glow', btn.dataset.hex);
      name.textContent = btn.dataset.pkPick.toUpperCase();
      tagline.textContent = btn.dataset.tagline;
      selected = btn.dataset.pkPick;
    }));
    const cta = root.querySelector('[data-pk-picker-cta]');
    if (cta) cta.addEventListener('click', (e) => {
      const buy = document.getElementById('pk-buy');
      if (!buy) return;
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('pickles:color', { detail: selected }));
      buy.scrollIntoView({ behavior: 'smooth' });
    });
  };

  const initSlider = (root) => {
    const track = root.querySelector('.pk-slider__track');
    const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 16 : 300);
    root.querySelector('[data-dir="prev"]').addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    root.querySelector('[data-dir="next"]').addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-pk-product]').forEach(initProduct);
    scope.querySelectorAll('[data-pk-picker]').forEach(initPicker);
    scope.querySelectorAll('[data-pk-slider]').forEach(initSlider);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  // Re-init when a section is edited in the Shopify theme editor.
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
